import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * Common chrome for every landing page (navbar + footer).
 *
 * A landing page defines its own list of in-page anchors once and passes them
 * in as `navLinks`; by default the same list is also reused as the footer's
 * "Product" column so the two stay in sync.
 *
 * Example:
 *
 *   const NAV_LINKS = [
 *     { href: '#how-it-works', label: 'How it works' },
 *     { href: '#strategies', label: 'Strategies' },
 *   ];
 *
 *   <SiteLayout navLinks={NAV_LINKS}>
 *     <Hero />
 *     <Strategies />
 *   </SiteLayout>
 */
export default function SiteLayout({
  children,
  navLinks = [],
  // Navbar overrides
  ctaHref,
  ctaLabel,
  signInHref,
  logoHref,
  // Footer overrides
  footerProductLinks,
  footerProductLabel,
  footerTagline,
  footerCompanyLinks,
  footerResourceLinks,
  footerLegalLinks,
}) {
  const productLinks = footerProductLinks ?? navLinks;

  return (
    <div className="min-h-screen bg-white text-ink-900 antialiased">
      <Navbar
        navLinks={navLinks}
        ctaHref={ctaHref}
        ctaLabel={ctaLabel}
        signInHref={signInHref}
        logoHref={logoHref}
      />
      <main>{children}</main>
      <Footer
        productLinks={productLinks}
        productLabel={footerProductLabel}
        tagline={footerTagline}
        companyLinks={footerCompanyLinks}
        resourceLinks={footerResourceLinks}
        legalLinks={footerLegalLinks}
      />
    </div>
  );
}
